var FloorplanHeader = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanHeader',
	};

	$.extend(true, this.options, options);

};

FloorplanHeader.prototype.init = function() {
	// Apply Now functionality is now handled by Modal trigger system
	// Buttons use href="#apply-now" and are handled in Modal.js
};

export default FloorplanHeader;
